"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var Product = {};
Product.LINK_TYPE = {
  UPSELL: "upsell"
};
var productProps = {
  name: _propTypes["default"].string.isRequired,
  id: _propTypes["default"].number,
  sku: _propTypes["default"].string.isRequired,
  labelText: _propTypes["default"].string,
  producer: _propTypes["default"].string,
  url: _propTypes["default"].string,
  price: _propTypes["default"].shape({
    regular: _propTypes["default"].number.isRequired,
    special: _propTypes["default"].number,
    lowest: _propTypes["default"].number,
    discountFromTotals: _propTypes["default"].number
  }),
  collection: _propTypes["default"].shape({
    name: _propTypes["default"].string,
    url: _propTypes["default"].string,
    id: _propTypes["default"].string
  }),
  relatedProducts: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    linkType: _propTypes["default"].string,
    sku: _propTypes["default"].string
  })),
  logo: _propTypes["default"].shape({
    alt: _propTypes["default"].string,
    src: _propTypes["default"].array
  }),
  info: _propTypes["default"].shape({
    description: _propTypes["default"].string,
    shortDescription: _propTypes["default"].string,
    technicalData: _propTypes["default"].arrayOf(_propTypes["default"].object)
  }),
  availability: _propTypes["default"].shape({
    name: _propTypes["default"].string,
    level: _propTypes["default"].string,
    stock: _propTypes["default"].string
  }),
  category: _propTypes["default"].shape({
    id: _propTypes["default"].number,
    ids: _propTypes["default"].arrayOf(_propTypes["default"].number),
    parentId: _propTypes["default"].string
  }),
  images: _propTypes["default"].arrayOf(_propTypes["default"].object),
  image: _propTypes["default"].object.isRequired,
  pickedOptions: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    attribute_code: _propTypes["default"].string.isRequired,
    label: _propTypes["default"].string.isRequired,
    name: _propTypes["default"].string.isRequired,
    value: _propTypes["default"].string.isRequired
  })),
  otherVariants: _propTypes["default"].array,
  isNew: _propTypes["default"].bool
};
Product.AVAILABILITY = {
  OUT_OF_STOCK: 117,
  LOW_AVAILABILITY: 118
};
Product.shape = function () {
  for (var _len = arguments.length, props = new Array(_len), _key = 0; _key < _len; _key++) {
    props[_key] = arguments[_key];
  }
  return props.length > 0 ? _propTypes["default"].shape(props.reduce(function (current, prop) {
    return _objectSpread(_objectSpread({}, current), {}, (0, _defineProperty2["default"])({}, prop, productProps[prop]));
  }, {})) : _propTypes["default"].shape(productProps);
};
var _default = Product;
exports["default"] = _default;